import { FC } from 'react';
import { ComponentRendering, Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { icon_basket } from '@gn-audio/icons';
import { Button } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';

import { getSharedProperty } from 'common/getters';
import { withTheme } from 'common/jabraTheme/withTheme';
import { usePageProduct } from 'common/PageProductContext/pageProductContext';
import { SitecoreDictionaryPhrase } from 'common/types/sitecore';
import { ComponentProps } from 'lib/component-props';

export interface SupportSpotProps extends Omit<ComponentProps, 'rendering'> {
  rendering: {
    fields: {
      HeadingShared: {
        fields: SitecoreDictionaryPhrase;
      };
      MainTextShared: {
        fields: SitecoreDictionaryPhrase;
      };
      ButtonTextShared: {
        fields: SitecoreDictionaryPhrase;
      };
      BackgroundColor: Field<string>;
    };
  } & ComponentRendering;
  error?: { message?: string };
}

const SupportSpot: FC<SupportSpotProps> = ({ rendering }) => {
  const { product } = usePageProduct();

  if (!rendering.fields) return null;
  const heading = getSharedProperty(rendering.fields.HeadingShared.fields, 'Phrase')?.value;
  const mainText = getSharedProperty(rendering.fields.MainTextShared.fields, 'Phrase')?.value;
  const buttonText = getSharedProperty(rendering.fields.ButtonTextShared.fields, 'Phrase')?.value;

  return (
    <div className="bg-theme container-fluid">
      <div className="container mx-auto flex flex-col items-center text-center">
        <h2 className="heading-2">{heading}</h2>
        <p className="paragraph-large mb-6">{mainText}</p>
        <Button
          asLink
          href={product?.supportPageUrl}
          size="m"
          variant="primary"
          title={buttonText}
          icon={<JabraIcon Icon={icon_basket} />}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default withTheme({ legacyBackgroundFieldName: 'BackgroundColorShared' })(
  withDatasourceCheck()(SupportSpot)
);
